<template>
  <v-card
    class="mx-auto grey lighten-4"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        mdi-cast-education
      </v-icon>
      <img
        :src="require('../../assets/logo_qclass_agenda.png')"
        alt="Qclass EAD"
        align="center"
        justify="center"
        contain
        height="35x"
        max-height="60px"
      >
      <v-spacer />
    </v-card-title>
    <v-btn
      fab
      fixed
      right
      bottom
      style="bottom: 8.5%; right: 4.5%"
      color="blue lighten-1"
      :loading="loading"
      @click="initialize"
    >
      <v-icon color="white">
        update
      </v-icon>
    </v-btn>
    <v-card-text class="headline font-weight-bold">
      <v-data-table
        :headers="headers"
        :items="aulas"
        :loading="loading"
        sort-by="data_hora"
        class="elevation-1"
        locale="pt-BR"
      >
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="getColor(item.status)"
            dark
          >
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.plano_aula_id="{ item }">
          <span>Desempenho: {{ item.plano_aula_id }}</span>
          <v-icon
            small
            class="ml-2"
            @click="navigateToDesempenho(item.plano_aula_id)"
          >
            mdi-account-box
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            :disabled="!item.allowDelete"
            @click="deleteItem(item.id)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <p>Nenhuma aula encontrada.</p>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { format, parseISO } from 'date-fns';
import AulaApi from '../../ws/aula';

  export default {
    data: () => ({
      dialog: false,
      loading: false,
      headers: [
        { text: '#ID', align: 'start', value: 'id', sortable: true, },
        { text: 'Data Agenda', value: 'data_hora', sortable: false, },
        { text: 'Categoria', value: 'veiculo.categoria', sortable: false,},
        { text: 'Carga Horária', value: 'carga_horaria', sortable: false,},
        { text: 'Instrutor', value: 'instrutor.nome', sortable: false,},
        { text: 'Veículo (Placa)', value: 'veiculo.placa', sortable: false,},
        { text: 'Status', value: 'status',sortable: true, },
        { text: 'Visualizar Desempenho (Plano Aula)', value: 'plano_aula_id', sortable: true, },
        { text: 'Ações', value: 'actions', sortable: false, },
      ],
      aulas: [],
      aluno:{},
    }),

    computed: {},
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        this.loading = true;
        this.aluno = await this.$store.getters.getAluno;
        await AulaApi.findAllAulasByCpf(this.aluno.cpf).then((response) => {
          this.loading = false;
          this.aulas = response.data;
          this.aulas.map(aula => {
            aula.data_hora = format(parseISO(aula.data_hora), 'dd/MM/yyyy HH:mm');
            if (aula.status =='PLANEJADA') {
              aula.status ='AGENDADA'
              aula.allowDelete = true;
            }
          });
        });

      },
      getColor(status) {
        if (status === 'REALIZADA') return 'green'
        else if (status === 'AGENDADA') return 'blue'
        else if (status === 'CANCELADA') return 'red'
        else if (status === 'EM ANDAMENTO') return 'orange'
        else return 'white'
      },
      async deleteItem (id) {
        if(confirm('Deseja deletar esta aula ?')){
          try {
            await AulaApi.deleteById(id);
            alert('Sucesso');
          } catch (error) {
            const { status, data } = error.response;
            alert(`${status} - ${data.error}`)
          }
        }
      },
      navigateToDesempenho(idPlano) {
        this.$router.push(`/aulas/desempenho/${idPlano}`);
      },
    },
  }
</script>
